import InsightsSearch from './InsightsSearch';

export { type InsightsSearchProps } from './InsightsSearch';
export default InsightsSearch;
